import {
  PHONE_EXIST_REQUEST,
  PHONE_EXIST_SUCCESS,
  PHONE_EXIST_FAILURE,
  PHONE_IS_VERIFIABLE,
  EMAIL_EXIST_REQUEST,
  EMAIL_EXIST_SUCCESS,
  EMAIL_EXIST_FAILURE,
  UPDATE_USER,
  UPDATE_USER_REQUEST,
  UPDATE_USER_ERROR,
  UPDATE_USER_SUCCESS,
  USER_VERIFY_SUCCESS,
  CONFIRM_PHONE_NUMBER_SUCCESS,
  CONFIRM_PHONE_NUMBER_REQUEST,
  CONFIRM_PHONE_NUMBER_ERROR,
  USER_VERIFY_ERROR,
  USER_VERIFY_REQUEST,
  LOGIN_SUCCESS,
  REFRESH_ACCESS_TOKEN_SUCCESS,
  LOGIN_REQUEST,
  LOGIN_ERROR,
  LOGOUT_USER,
  CLEAR_AUTH_ERROR,
  TAC_SUCCESS,
  TAC_REQUEST,
  TAC_ERROR,
  SET_NEW_USER,
  GET_REQUIREMENTS_SUCCESS,
  GET_REQUIREMENTS_REQUEST,
  TAC_UPDATE_REQUEST,
  TAC_UPDATE_SUCCESS,
  TAC_UPDATE_ERROR,
} from '../actions/AuthAction'
import { mergeDeepRight } from 'ramda'

const initState = {
  isFetching: false,
  user: {
    id: '',
    firstname: '',
    lastname: '',
    phone: '',
    email: '',
    isAuthenticated: false,
  },
  newUser: undefined,
  requirements: {},
  isFetchingRequirements: false,
  isUpdatingTac: false,
}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_NEW_USER:
      return Object.assign({}, state, {
        newUser: {
          ...state.newUser,
          ...action.newUser,
        },
      })
    case UPDATE_USER:
      return Object.assign({}, state, {
        user: {
          ...state.user,
          ...action.user,
        },
        error: null,
      })
    case UPDATE_USER_SUCCESS:
      return Object.assign({}, state, {
        user: {
          ...state.user,
          ...action.userInfo,
        },
      })
    case UPDATE_USER_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
      })
    case UPDATE_USER_ERROR:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error,
      })
    case PHONE_EXIST_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        user: {
          ...state.user,
          mobileNumber: action.mobileNumber,
        },
        error: null,
      })
    case PHONE_IS_VERIFIABLE:
      return Object.assign({}, state, {
        phoneIsVerifiable: action.isVerifiable,
      })
    case PHONE_EXIST_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        didUserExistRequest: true,
        user: {
          ...state.user,
          userExist: action.userExist,
          mobileNumber: action.mobileNumber,
        },
        error: null,
      })
    }
    case PHONE_EXIST_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        didUserExistRequest: true,
        user: {
          ...state.user,
          userExist: undefined,
          mobileNumber: action.mobileNumber,
        },
        error: action.error,
      })
    case EMAIL_EXIST_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
        user: {
          ...state.user,
          email: action.email,
        },
        error: null,
      })
    case EMAIL_EXIST_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        didUserExistRequest: true,
        user: {
          ...state.user,
          userExist: action.userExist,
          email: action.email,
        },
        error: null,
      })
    }
    case EMAIL_EXIST_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        didUserExistRequest: true,
        user: {
          ...state.user,
          userExist: undefined,
          email: action.email,
        },
        error: action.error,
      })
    case USER_VERIFY_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        user: {
          ...state.user,
          ...action.user,
        },
      })
    case USER_VERIFY_ERROR:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error,
      })
    case USER_VERIFY_REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
      })
    case CONFIRM_PHONE_NUMBER_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true,
      })
    }
    case CONFIRM_PHONE_NUMBER_ERROR: {
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error,
      })
    }
    case CONFIRM_PHONE_NUMBER_SUCCESS:
    case LOGIN_SUCCESS: {
      const { user = {} } = action
      const { accessToken, refreshToken, userId, ...props } = user
      return Object.assign({}, state, {
        isFetching: false,
        error: null,
        user: {
          ...state.user,
          ...props,
          isAuthenticated: true,
          accessToken,
          refreshToken,
          id: userId,
        },
      })
    }
    case REFRESH_ACCESS_TOKEN_SUCCESS: {
      const { accessToken, refreshToken } = action
      return Object.assign({}, state, {
        isFetching: false,
        error: null,
        user: {
          ...state.user,
          accessToken,
          refreshToken,
        },
      })
    }
    case LOGIN_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true,
      })
    }
    case LOGIN_ERROR: {
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error,
      })
    }
    case TAC_SUCCESS: {
      const { tac } = action
      return Object.assign({}, state, {
        isFetching: false,
        error: null,
        tac: tac,
      })
    }
    case TAC_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true,
      })
    }
    case TAC_UPDATE_REQUEST: {
      return Object.assign({}, state, {
        isUpdatingTac: true,
      })
    }
    case TAC_UPDATE_SUCCESS: {
      return Object.assign({}, state, {
        isUpdatingTac: false,
        error: null,
        user: mergeDeepRight(state.user, {
          tac: {
            intake: {
              version: action.tacVersionId,
            },
          },
        }),
      })
    }
    case TAC_UPDATE_ERROR: {
      const { error } = action
      return Object.assign({}, state, {
        isUpdatingTac: false,
        error,
      })
    }
    case GET_REQUIREMENTS_SUCCESS: {
      const { requirements } = action
      return Object.assign({}, state, {
        isFetchingRequirements: false,
        error: null,
        requirements,
      })
    }
    case GET_REQUIREMENTS_REQUEST: {
      return Object.assign({}, state, {
        isFetchingRequirements: true,
      })
    }
    case TAC_ERROR: {
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error,
      })
    }
    case LOGOUT_USER: {
      return initState
    }
    case CLEAR_AUTH_ERROR: {
      return Object.assign({}, state, {
        error: null,
      })
    }
    case 'RESET':
      return initState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/AuthReducer.js